import PropTypes from "prop-types";
import { Col, Row } from "reactstrap";
import { useContext } from "react";
import { toast } from "../../../../core/helpers/message-helper";
import FormModal from "../../../../core/ui/components/FormModal";
import { useForm } from "react-hook-form";
import TurnosConvencionesContext from "../../store/modal-convenciones-context";
import { eliminarCuadroTurnos } from "../../services/nomina-cuadro-turnos";
import DateRangePicker from "../../../../core/ui/components/DateRangePicker";
import { validarRangoDeFecha } from "../../helpers/cuadro-turnos-helper";
import moment from "moment";
import { useState } from "react";

const FormEliminarCuadroTurno = ({
    modal,
    onEliminarCuadroTurnos,
    sedeAreaLider,
}) => {
    const { refrescarConvenciones } = useContext(TurnosConvencionesContext);
    const [rangoFecha, setRangoFecha] = useState({
        fechaInicio: null,
        fechaFin: null,
    });

    const defaultValues = {
        fechaCuadroTurnoFin: "",
        fechaCuadroTurnoInicio: "",
    };

    const form = useForm({ defaultValues });

    const onSubmit = async (data) => {
        data.fechaCuadroTurnoInicio = rangoFecha.fechaInicio;
        data.fechaCuadroTurnoFin = rangoFecha.fechaFin;
        sedeAreaLider && (data.idSedeArea = sedeAreaLider);
        const response = await eliminarCuadroTurnos(data);

        response.status
            ? toast.success(response.message)
            : toast.error(response.message);

        response.status && onEliminarCuadroTurnos();
        refrescarConvenciones();
    };

    const onChangeDateRange = function (inicio, fin) {
        const fechaInicio = inicio.format("YYYY-MM-DD");
        const fechaFin = fin.format("YYYY-MM-DD");
        const esRangoValido = validarRangoDeFecha(fechaInicio, fechaFin, 31);

        if (!esRangoValido) {
            return toast.error(
                "El rango de fecha no puede ser mayor a 31 días"
            );
        }

        setRangoFecha({ fechaInicio, fechaFin });
    };

    return (
        <FormModal
            size="lg"
            form={form}
            isOpen={modal.show}
            onSubmit={onSubmit}
            id="formCrearCuadroTurnoAutomatico"
            headerTitle="Eliminar cuadro de turno automatico"
            closeModal={() => modal.close()}
        >
            <Row>
                <Col sm={12}>
                    <DateRangePicker
                        id="cuadroTurnoAutomaticoFecha"
                        startDate={moment()}
                        onChangeRange={onChangeDateRange}
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormEliminarCuadroTurno.propTypes = {
    modal: PropTypes.object,
    onEliminarCuadroTurnos: PropTypes.func,
    sedeAreaLider: PropTypes.string,
};

export default FormEliminarCuadroTurno;
